import React from 'react';
import clsx from 'clsx';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Image} from '@shopify/hydrogen';
import {useLoaderData} from '@remix-run/react';
import {Product as ProductType} from '@shopify/hydrogen/storefront-api-types';
import {Swiper as SwiperClass} from 'swiper';

//data
import {loader} from '~/routes/($lang)/products/$productHandle';

//components
import Container from 'components/Container';
import Product from 'components/product/Product';
import {Skeleton} from 'components/Skeleton';

export default function ProductDetailsRecommendations({
  products,
}: {
  products: ProductType[];
}) {
  const {productSettings} = useLoaderData<typeof loader>();
  const carouselMainRef = React.useRef<SwiperClass>();
  return (
    <section className="recommended-products my-20">
      <Container>
        <h3
          className={clsx(
            'mb-6 text-center font-bold uppercase', //
            'text-[24px]',
          )}
        >
          {productSettings?.product_settings_translations
            ?.you_may_also_like_label ? (
            <>
              {
                productSettings?.product_settings_translations
                  ?.you_may_also_like_label
              }
            </>
          ) : (
            'you may also like'
          )}
        </h3>
        <div className="relative px-6 lg:px-0">
          <Swiper
          onSwiper={(swiper) => {
            carouselMainRef.current = swiper;
          }}
            breakpoints={{
              320: {
                spaceBetween: 20,
                slidesPerView: 2,
              },
              768: {
                spaceBetween: 20,
                slidesPerView: 3,
              },
              1024: {
                spaceBetween: 40,
                slidesPerView: 5,
              },
            }}
            loop={true}
          >
            {products &&
              products.map((product) => {
                if (product) {
                  return (
                    <SwiperSlide key={product.id}>
                      <Product product={product} quickAdd/>
                    </SwiperSlide>
                  );
                }
                return;
              })}
          </Swiper>
          <button
        onClick={() => carouselMainRef.current?.slidePrev()}
        className={clsx(
          'absolute left-0 top-1/2 z-10  -translate-y-1/2 -translate-x-2 lg:-translate-x-10',
          products && products?.length < 4 && 'lg:hidden',
          products && products?.length < 3 && 'hidden',
        )}
      >
        <svg
          width="35"
          height="35"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="rotate-90"
        >
          <path
            d="M9.75 4.5L6 8.25L2.25 4.5"
            stroke="#3A3E3E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button
        onClick={() => carouselMainRef.current?.slideNext()}
        className={clsx(
          'absolute right-0 top-1/2 z-10 -translate-y-1/2 translate-x-2 lg:translate-x-10',
          products && products?.length < 4 && 'lg:hidden',
          products && products?.length < 3 && 'hidden',
        )}
      >
        <svg
          width="35"
          height="35"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="-rotate-90"
        >
          <path
            d="M9.75 4.5L6 8.25L2.25 4.5"
            stroke="#3A3E3E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
        </div>
      </Container>
    </section>
  );
}
